<template>
  <v-card>
    <form-container>
      <v-flex xs12 class="flex-container-space-between vertical-center-container">
        <div class="vertical-center-container">
          <v-icon
            large
            class="mr-2"
            :color="$store.state.global.pages.docket.color"
          >{{$store.state.global.pages.docket.icon}}</v-icon>
          <span class="headline">
            Trip {{trip.id}}
            <span
              class="grey--text subheading"
            >- Docket ({{trip.docket.externalRef || trip.docket.id}})</span>
          </span>
        </div>
        <div class="vertical-center-container">
          <v-tooltip top v-if="userAuthClass && !trip.rctiId && !trip.billId">
            <v-btn slot="activator" icon flat color="grey" @click="$emit('seeEditTrip')">
              <v-icon>edit</v-icon>
            </v-btn>Edit Trip
          </v-tooltip>
          <v-tooltip top>
            <v-btn slot="activator" icon color="grey" flat @click="$emit('seeDocketDetails')">
              <v-icon>{{$store.state.global.pages.docket.icon}}</v-icon>
            </v-btn>Show Docket Details
          </v-tooltip>
        </div>
      </v-flex>
      <card-divider-header></card-divider-header>
      <flex-sub-header>
        <div class="flex-container-space-between">
          <div>{{trip.docket.site.name}}</div>
          <div>{{makeLongDate(trip.docket.date)}}</div>
        </div>
      </flex-sub-header>

      <v-flex xs12 class>
        <div>
          <div class="vertical-center-container">
            <div
              class="grey--text text--darken-1 body-2"
            >{{`${trip.docket.vehicle.name} (${trip.docket.vehicle.vehicleType.name})`}} / {{ trip.docket.driver.name}}</div>
          </div>
          <div class="grey--text">{{trip.docket.vehicle.contractor.name}}</div>
        </div>
      </v-flex>
      <card-divider-header></card-divider-header>

      <!-- <flex-sub-header>Trip Details</flex-sub-header> -->
      <v-flex xs12 sm6>
        <detail-field align="left" title="Tip" :value="trip.tip.name"></detail-field>
      </v-flex>
      <v-flex xs12 sm6>
        <detail-field align="left" title="Spoil" :value="trip.spoil.name"></detail-field>
      </v-flex>

      <flex-sub-header v-if="!!trip.hours">Timesheet</flex-sub-header>
      <v-flex v-if="!!trip.hours" class="grey--text flex-container-space-between">
        <div>
          {{Math.round(trip.hours * 100) / 100}} hrs
          <span
            v-if="!!trip.start"
          >({{`${getUTCTime(trip.start)} - ${getUTCTime(trip.end)}`}})</span>
        </div>
        <div class="text-xs-right" v-if="trip.breaks !=0 || trip.travel !=0">
          <span>includes</span>
          <span v-if="trip.breaks !=0">-{{trip.breaks}} Hour Breaks</span>
          <span v-if="trip.breaks !=0 && trip.travel !=0">
            <br />
          </span>
          <span v-if="trip.travel !=0">+{{trip.travel}} Hour Travel</span>
        </div>
      </v-flex>

      <flex-sub-header>Mass Declaration</flex-sub-header>
      <v-flex xs12 sm4>
        <detail-field align="right" title="Tip Weight" :value="trip.siteWeight.toString()"></detail-field>
      </v-flex>
      <v-flex xs12 sm4>
        <detail-field align="right" title="Site Weight" :value="trip.tipWeight.toString()"></detail-field>
      </v-flex>
      <v-flex xs12 sm4>
        <detail-field align="right" title="Scale Weight" :value="trip.scaleWeight.toString()"></detail-field>
      </v-flex>

      <flex-sub-header v-if="!!trip.costPrice">
        <div class="flex-container-space-between">
          <div>Cost</div>
          <div>Total</div>
        </div>
      </flex-sub-header>
      <v-flex class="flex-container-space-between grey--text" v-if="!!trip.costPrice">
        <div>${{Number(trip.costPrice).toFixed(2)}} / {{trip.costUnit}}</div>
        <div>${{Number(trip.costTotal).toFixed(2)}}</div>
      </v-flex>

      <flex-sub-header v-if="!!trip.sellPrice">Sell</flex-sub-header>
      <v-flex class="flex-container-space-between grey--text" v-if="!!trip.sellPrice">
        <div>${{Number(trip.sellPrice).toFixed(2)}} / {{trip.sellUnit}}</div>
        <div>${{Number(trip.sellTotal).toFixed(2)}}</div>
      </v-flex>

      <flex-sub-header v-if="!!trip.wbDocketNumber">W/B Docket #</flex-sub-header>
      <v-flex class="flex-container-space-between grey--text" v-if="!!trip.wbDocketNumber">
        <div>{{ trip.wbDocketNumber }}</div>
      </v-flex>

      <flex-sub-header v-if="!!trip.notes">Trips Notes</flex-sub-header>
      <v-flex class="flex-container-space-between grey--text" v-if="!!trip.notes">
        <div>{{trip.notes}}</div>
      </v-flex>

      <card-divider-header></card-divider-header>

      <flex-sub-header>Trip Confirmations</flex-sub-header>
      <v-flex class="grey--text">
        <div class="vertical-center-container mb-2">
          <v-icon class="mr-2" :color="trip.GPSConfirmed ? 'green lighten-3' : 'grey'">gps_fixed</v-icon>
          <div>{{trip.GPSNotes || 'No GPS information recorded'}}</div>
        </div>
        <div class="vertical-center-container mb-2">
          <v-icon
            class="mr-2"
            :color="trip.massDeclarationConfirmed ? 'green lighten-3' : 'grey'"
          >shopping_basket</v-icon>
          <div>{{trip.massDeclarationNotes || 'No Mass Declaration information recorded'}}</div>
        </div>
        <div class="vertical-center-container mb-2">
          <v-icon
            class="mr-2"
            :color="trip.tippingDocketConfirmed ? 'green lighten-3' : 'grey'"
          >delete_sweep</v-icon>
          <div>{{trip.tippingDocketNotes || 'No Tipping Docket information recorded'}}</div>
        </div>
      </v-flex>

      <card-divider-header></card-divider-header>
      <v-flex xs12 class="pb-3">
        <div class="grey--text">Entered by: {{trip.docket.createdBy.name}}</div>
      </v-flex>

      <!-- <flex-sub-header>Trip Details</flex-sub-header>
            <v-flex xs12 sm6 class="">
                
                <v-card hover class="straight-border">
                    <v-card-title class="subheading red lighten-1 red--text text--lighten-5">
                        Cost Details
                    </v-card-title>
                    <v-card-text class="grey--text text--darken-1">
                        <div>
                            Sold at <span class="font-weight-bold">${{trip.costPrice}}</span> per <span class="font-weight-bold">{{trip.costUnit}}</span>
                        </div>
                        <div v-if="trip.costUnit == 'TONNE'">
                            Moved <span class="font-weight-bold">{{trip.siteWeight}}</span> tonnes
                        </div>
                        <div v-if="trip.costUnit == 'HOUR'">
                            Trip took <span class="font-weight-bold">{{trip.hours}}</span> hours
                        </div>
                        <div class="text-xs-center mt-3 mb-3">
                            <v-progress-circular
                            :rotate="360"
                            :size="100"
                            :width="15"
                            :value="costPercentage"
                            color="red lighten-1"
                            >
                            <span class="font-weight-bold">
                                ${{ trip.costTotal }}
                            </span>
                            </v-progress-circular>
                        </div>
                        <div class="text-xs-right body-2">
                            Cost Total ${{trip.costTotal}}
                        </div>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12 sm6 class="">
                <v-card hover class="straight-border">
                    <v-card-title class="subheading green lighten-1 green--text text--lighten-5">
                            Sell Details
                    </v-card-title>
                    <v-card-text class="grey--text text--darken-1">
                        <div>
                            Sold at <span class="font-weight-bold">${{trip.sellPrice}}</span> per <span class="font-weight-bold">{{trip.sellUnit}}</span>
                        </div>
                        <div v-if="trip.costUnit == 'TONNE'">
                            Moved <span class="font-weight-bold">{{trip.siteWeight}}</span> tonnes
                        </div>
                        <div v-if="trip.costUnit == 'HOUR'">
                            Trip took <span class="font-weight-bold">{{trip.hours}}</span> hours
                        </div>
                        <div class="text-xs-center mt-3 mb-3">
                            <v-progress-circular
                            :rotate="360"
                            :size="100"
                            :width="15"
                            :value="sellPercentage"
                            color="green lighten-1"
                            >
                            <span class="font-weight-bold">
                                ${{ trip.sellTotal }}
                            </span>
                            </v-progress-circular>
                        </div>
                        <div class="text-xs-right body-2">
                            Sell Total ${{trip.sellTotal}}
                        </div>
                    </v-card-text>
                </v-card>
      </v-flex>-->
    </form-container>
  </v-card>
</template>

<script>
import FormatDates from "@/services/mixins/formatDates";
import RowInfoDisplay from "@/components/ui/rowInfoDisplay";
import DetailField from "@/components/ui/detailField";
export default {
  mixins: [FormatDates],
  data() {
    return {
      progressValue: 0
    };
  },
  methods: {
    getPercentOfNumber(small, large) {
      return Math.floor((small / large) * 100);
    }
  },
  computed: {
    sellPercentage() {
      var sellPercentage = this.getPercentOfNumber(
        this.trip.sellTotal,
        this.trip.costTotal
      );
      if (sellPercentage >= 100) {
        return 100;
      }
      return sellPercentage;
    },
    costPercentage() {
      var costPercentage = this.getPercentOfNumber(
        this.trip.costTotal,
        this.trip.sellTotal
      );
      if (costPercentage >= 100) {
        return 100;
      }
      return costPercentage;
    }
  },
  props: {
    trip: Object
  },
  components: {
    RowInfoDisplay,
    DetailField
  },
  mounted() {}
};
</script>

<style>
.straight-border {
  border-radius: 2px !important;
}
</style>
